import { render, staticRenderFns } from "./VisualizarEmpenho.vue?vue&type=template&id=f946c542&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./VisualizarEmpenho.vue?vue&type=style&index=0&id=f946c542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f946c542",
  null
  
)

export default component.exports